define([
	"dojo/_base/declare",
	"./NewBreadcrumbSupplierRequest"
], function(declare,NewBreadcrumbSupplierRequest) {

	return declare(NewBreadcrumbSupplierRequest, {
		fixedType: "DataPackageContainerType:Style"
	});
});